/**
 * Whether the current window is narrow enough to be treated as a
 * mobile/tablet viewport for layout and default-tool purposes.
 *
 * Evaluated at call time (not cached), so call it fresh at the point where
 * a responsive decision is made (e.g. mode/layout entry, tool-group init)
 * rather than once at module load.
 *
 * @param breakpoint - max width, in CSS pixels, still considered mobile.
 *   Defaults to 1024 (covers phones and most tablets in portrait/landscape).
 */
export function isMobileViewport(breakpoint = 1024): boolean {
  return window.innerWidth <= breakpoint;
}

export default isMobileViewport;
